// ========================================
// Documentos del personal (diseño «M · Documentos del personal»): personas a la izquierda
// (solo quien ve la de todos), carpetas y archivos en el centro y el archivo elegido a la vista.
// ========================================

const ProfessorDocs = {
    ownerId: null,
    selectedOwner() { return this.canReadAll() ? this.ownerId || AuthManager.currentUser?.professorId : AuthManager.currentUser?.professorId; },
    canReadAll() { return AuthManager.isAdmin() || AuthManager.isRRHH() || AuthManager.hasModule('documentos'); },
    canManage() { return !!this.selectedOwner() && (AuthManager.canManageModule('documentos',['admin','rrhh']) || AuthManager.isProfessor() && this.selectedOwner()===AuthManager.currentUser.professorId); },
    selectOwner(id) {
        if(!this.canReadAll())return;
        this.ownerId=id;this.currentFolderId=null;this.breadcrumbs=[];this.selectedId=null;
        this.refresh();
    },
    STORAGE_KEY: 'ecpv_professor_docs',
    currentFolderId: null, // null = root
    breadcrumbs: [], // [{id, name}]
    selectedId: null,
    peopleSearch: '',

    render() {
        const currentUser = AuthManager.currentUser;
        if (!currentUser || (!currentUser.professorId && !this.canReadAll())) {
            return `
                <div class="view-container">
                    <div class="empty-state" style="padding: 5rem 1rem; text-align: center;">
                        <i class="fas fa-exclamation-circle" style="font-size: 3rem; color: var(--text-tertiary); margin-bottom: 1.5rem;"></i>
                        <h3>Acceso Restringido</h3>
                        <p>Esta sección es exclusiva para profesores.</p>
                    </div>
                </div>
            `;
        }
        const manage = this.canManage() ? '' : 'disabled';

        return `
            <div class="view-container dnr-proposal dv" id="docs-page">
                <div class="dv-head">
                    <div class="dv-head-text">
                        <span class="dv-mono">${this.canReadAll() ? 'Personal y RRHH · Documentación' : 'Mi espacio · Documentación'}</span>
                        <h1 class="dv-title">${this.canReadAll() ? 'Documentos' : 'Mis documentos'}</h1>
                        <span class="dv-sub">Contratos, titulaciones y papeles ordenados en carpetas.</span>
                    </div>
                    <div class="dv-head-actions">
                        <button type="button" class="dv-btn" id="docs-new-folder-btn" ${manage} ${UIEvents.attr("click", function(event,captured){ProfessorDocs.openNewFolderModal();}, [])}>
                            <i class="fas fa-folder-plus" aria-hidden="true"></i> Nueva carpeta
                        </button>
                        <button type="button" class="dv-btn is-primary" id="docs-upload-btn" ${manage} ${UIEvents.attr("click", function(event,captured){ProfessorDocs.openUploadModal();}, [])}>
                            <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i> Subir archivo
                        </button>
                    </div>
                </div>
                <input type="file" id="docs-file-input" class="dv-sr-only" accept="application/pdf,image/png,image/jpeg,image/gif,image/webp" tabindex="-1" aria-hidden="true">

                <div class="dv-layout ${this.canReadAll() ? 'has-people' : ''}">
                    ${this.canReadAll() ? `
                    <section class="dv-card dv-people" aria-labelledby="dv-people-title">
                        <div class="dv-people-head">
                            <h2 class="dv-h2" id="dv-people-title">Personas · ${DataManager.getProfessors().length}</h2>
                            <label class="dv-search">
                                <i class="fas fa-search" aria-hidden="true"></i>
                                <input type="search" id="document-owner-search" placeholder="Buscar persona" aria-label="Buscar persona" value="${Utils.sanitizeHTML(this.peopleSearch)}"
                                    ${UIEvents.attr('input', function(){ProfessorDocs.peopleSearch=this.value;ProfessorDocs.refreshPeople();})}>
                            </label>
                        </div>
                        <ul class="dv-people-list" id="dv-people-list">${this.renderPeople()}</ul>
                        <p class="dv-foot">Cada profesor ve solo la suya: a él no le sale esta columna.</p>
                    </section>` : ''}
                    <section class="dv-card dv-main" id="dv-main" aria-labelledby="dv-owner-title">${this.renderMain()}</section>
                    <aside class="dv-card dv-detail" id="dv-detail" aria-label="Archivo elegido">${this.renderDetail()}</aside>
                </div>
            </div>

            <!-- Modal: New Folder -->
            <div id="modal-new-folder" class="modal-overlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; backdrop-filter: blur(2px); align-items: center; justify-content: center;">
                <div class="card dv-folder-modal" role="dialog" aria-modal="true" aria-labelledby="dv-folder-title">
                    <h3 id="dv-folder-title">Nueva carpeta</h3>
                    <p class="dv-sub" id="dv-folder-where"></p>
                    <div class="form-group">
                        <label class="form-label" for="folder-name-input">Nombre de la carpeta</label>
                        <input type="text" id="folder-name-input" class="form-select" placeholder="Ej.: Contratos" style="width: 100%;"
                            ${UIEvents.attr('keydown', function(event){if(event.key==='Enter'){event.preventDefault();ProfessorDocs.createFolder();}})}>
                    </div>
                    <div style="display: flex; justify-content: flex-end; gap: 0.75rem; margin-top: 1.25rem;">
                        <button type="button" class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){ProfessorDocs.closeModal('modal-new-folder');}, [])}>Cancelar</button>
                        <button type="button" class="btn btn-primary" ${UIEvents.attr("click", function(event,captured){ProfessorDocs.createFolder();}, [])}>Crear</button>
                    </div>
                </div>
            </div>

            <!-- Modal: Preview (Shared style) -->
            <div id="docs-preview-modal" class="modal-overlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.85); z-index: 10000; backdrop-filter: blur(4px); align-items: center; justify-content: center; opacity: 0; transition: opacity 0.3s ease;">
                <div class="modal-container" style="width: 90%; max-width: 1000px; height: 90%; background: var(--bg-primary); border-radius: 16px; position: relative; display: flex; flex-direction: column; overflow: hidden; transform: scale(0.9); transition: transform 0.3s ease;">
                    <div class="modal-header" style="padding: 1rem 1.5rem; background: var(--bg-secondary); border-bottom: 1px solid var(--border-color); display: flex; justify-content: space-between; align-items: center;">
                        <h3 id="docs-modal-title" style="margin: 0; font-size: 1.1rem; color: var(--text-primary);">Vista Previa</h3>
                        <div style="display: flex; gap: 0.75rem;">
                            <button id="docs-modal-download" class="btn btn-sm btn-primary">
                                <i class="fas fa-download"></i> Descargar
                            </button>
                            <button ${UIEvents.attr("click", function(event,captured){ProfessorDocs.closePreview();}, [])} class="btn-icon" aria-label="Cerrar">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div id="docs-modal-content" style="flex: 1; display: flex; align-items: center; justify-content: center; background: #e2e8f0; overflow: auto; padding: 1rem;"></div>
                </div>
            </div>
        `;
    },

    init() {
        this.setupDropZone();
        this.loadDetailPreview();
    },

    // Every record, not only the selected owner's: the people column counts each person's files.
    allRecords() {
        const data = BrowserState.getItem(this.STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    },

    getAllDocs() {
        return this.allRecords().filter(d => d.professorId === this.selectedOwner());
    },

    async saveDocs(docs) {
        if(!this.canManage() || !this.selectedOwner())return false;
        let allDocs = this.allRecords();

        // Remove current professor docs from global list and add updated ones
        allDocs = allDocs.filter(d => d.professorId !== this.selectedOwner());
        allDocs.push(...docs);

        const globalWrite=AuthManager.canManageModule('documentos',['admin','rrhh']);
        try { await FileStorage.writeConfirmed(this.STORAGE_KEY, globalWrite?allDocs:docs); }
        catch(error) { Utils.showToast(error.message, 'error'); return false; }
        // A read-all / write-own grant must not submit other people's records.
        BrowserState.setItem(this.STORAGE_KEY,JSON.stringify(allDocs));
        FileStorage.dataStore.professorDocs=allDocs;

        // Refresh sidebar tree if available
        if (window.App && App.renderSidebarFolderTree) {
            App.renderSidebarFolderTree();
        }
        return true;
    },

    plural(n, one, many) { return `${n} ${n === 1 ? one : many}`; },
    initials(name) { return String(name || '').split(/\s+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2).toUpperCase() || '?'; },
    ownerName(id) {
        const p = DataManager.getProfessors().find(x => x.id === id);
        return p ? `${p.firstName || ''} ${p.lastName || ''}`.trim() : (id === AuthManager.currentUser?.professorId ? AuthManager.currentUser?.name || 'Mis documentos' : '—');
    },
    isPdf(item) { return String(item.fileType || '').includes('pdf'); },
    formatDate(iso) {
        const date = new Date(iso);
        return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
    },
    currentFolderName() { return this.breadcrumbs.at(-1)?.name || 'Inicio'; },
    folderPath(id, docs = this.getAllDocs()) {
        const names = [];
        for (let folder = docs.find(d => d.id === id); folder; folder = docs.find(d => d.id === folder.parentId)) names.unshift(folder.name);
        return names.length ? names.join(' › ') : 'Inicio';
    },

    // Drag a file or folder onto a folder tile or a crumb of the path to move it there.
    DRAG_TYPE: 'application/x-sicaf-doc',
    dragAttrs(id) {
        if (!this.canManage()) return '';
        return `draggable="true" ${UIEvents.attr('dragstart', function(event,captured){ProfessorDocs.startDrag(event, String(captured[0]));}, [id])} ${UIEvents.attr('dragend', function(){ProfessorDocs.endDrag();})}`;
    },
    dropAttrs(folderId) {
        if (!this.canManage()) return '';
        const target = folderId === null ? '' : folderId;
        return `${UIEvents.attr('dragover', function(event,captured){ProfessorDocs.dragOver(event, this, captured[0] || null);}, [target])}
            ${UIEvents.attr('dragleave', function(){this.classList.remove('is-drop');})}
            ${UIEvents.attr('drop', function(event,captured){ProfessorDocs.dropOn(event, this, captured[0] || null);}, [target])}`;
    },
    startDrag(event, id) {
        this._dragId = id;
        event.dataTransfer?.setData(this.DRAG_TYPE, id);
        event.dataTransfer?.setData('text/plain', this.getAllDocs().find(d => d.id === id)?.name || '');
        if (event.dataTransfer) event.dataTransfer.effectAllowed = 'move';
        document.getElementById('dv-main')?.classList.add('is-dragging');
    },
    endDrag() {
        this._dragId = null;
        document.getElementById('dv-main')?.classList.remove('is-dragging');
        document.querySelectorAll('#dv-main .is-drop').forEach(node => node.classList.remove('is-drop'));
    },
    canMoveTo(id, folderId) {
        const docs = this.getAllDocs();
        const item = docs.find(d => d.id === id);
        if (!item || (item.parentId ?? null) === folderId || item.id === folderId) return false;
        // A folder cannot go inside itself or one of its own subfolders.
        for (let f = docs.find(d => d.id === folderId); f; f = docs.find(d => d.id === f.parentId)) if (f.id === item.id) return false;
        return true;
    },
    dragOver(event, node, folderId) {
        if (!this._dragId || !this.canMoveTo(this._dragId, folderId)) return;
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        node.classList.add('is-drop');
    },
    dropOn(event, node, folderId) {
        node.classList.remove('is-drop');
        const id = this._dragId;
        if (!id) return;
        event.preventDefault();
        event.stopPropagation();
        this.endDrag();
        this.moveItem(id, folderId);
    },

    async moveItem(id, folderId) {
        if (!this.canManage() || !this.canMoveTo(id, folderId)) return;
        const docs = this.getAllDocs();
        const item = docs.find(d => d.id === id);
        const previous = item.parentId ?? null;
        item.parentId = folderId;
        if (!await this.saveDocs(docs)) { item.parentId = previous; return; }
        if (this.selectedId === id && folderId !== this.currentFolderId) this.selectedId = null;
        this.refresh();
        Utils.showToast(`«${item.name}» movido a «${this.folderPath(folderId)}»`, 'success');
    },

    renderPeople() {
        const all = this.allRecords();
        const query = Utils.normalizeSearchText ? Utils.normalizeSearchText(this.peopleSearch) : this.peopleSearch.toLowerCase().trim();
        const people = DataManager.getProfessors()
            .map(p => ({ id: p.id, name: `${p.firstName || ''} ${p.lastName || ''}`.trim() }))
            .filter(p => !query || (Utils.normalizeSearchText ? Utils.normalizeSearchText(p.name) : p.name.toLowerCase()).includes(query))
            .sort((a, b) => a.name.localeCompare(b.name, 'es'));
        if (!people.length) return '<li class="dv-empty-small">Nadie con ese nombre.</li>';
        const selected = this.selectedOwner();
        return people.map(p => {
            const files = all.filter(d => d.professorId === p.id && d.type !== 'folder').length;
            const on = p.id === selected;
            return `<li><button type="button" class="dv-person ${on ? 'is-on' : ''}" ${on ? 'aria-current="true"' : ''} ${UIEvents.attr('click', function(event,captured){ProfessorDocs.selectOwner(String(captured[0]));}, [p.id])}>
                <span class="dv-avatar" aria-hidden="true">${Utils.sanitizeHTML(this.initials(p.name))}</span>
                <span class="dv-person-text"><strong>${Utils.sanitizeHTML(p.name)}</strong><span>${files ? this.plural(files, 'archivo', 'archivos') : 'Sin documentos'}</span></span>
                ${files ? '' : '<span class="dv-pill is-warn">Vacía</span>'}
            </button></li>`;
        }).join('');
    },

    renderMain() {
        const owner = this.selectedOwner();
        if (!owner) {
            return `<div class="dv-choose"><i class="fas fa-user-friends" aria-hidden="true"></i><strong id="dv-owner-title">Elige una persona</strong><span>Pulsa a alguien de la columna de la izquierda para ver sus carpetas y archivos.</span></div>`;
        }
        const docs = this.getAllDocs();
        const name = this.ownerName(owner);
        const totalFiles = docs.filter(d => d.type !== 'folder').length;
        const totalFolders = docs.filter(d => d.type === 'folder').length;
        const here = docs.filter(d => d.parentId === this.currentFolderId);
        const folders = here.filter(d => d.type === 'folder').sort((a, b) => a.name.localeCompare(b.name, 'es'));
        const files = here.filter(d => d.type !== 'folder').sort((a, b) => String(b.timestamp || '').localeCompare(String(a.timestamp || '')));
        const inside = id => docs.filter(d => d.parentId === id).length;
        const where = this.currentFolderName();
        const manage = this.canManage();

        return `
            <div class="dv-main-head">
                <div class="dv-owner">
                    <span class="dv-avatar is-big" aria-hidden="true">${Utils.sanitizeHTML(this.initials(name))}</span>
                    <span class="dv-person-text"><h2 id="dv-owner-title">${Utils.sanitizeHTML(name)}</h2><span>${this.plural(totalFiles, 'archivo', 'archivos')} · ${this.plural(totalFolders, 'carpeta', 'carpetas')}</span></span>
                </div>
                <nav class="dv-crumbs docs-breadcrumbs" aria-label="Ruta">
                    <button type="button" class="dv-crumb ${this.currentFolderId ? '' : 'is-on'}" ${this.currentFolderId ? '' : 'aria-current="page"'} ${this.dropAttrs(null)} ${UIEvents.attr("click", function(event,captured){ProfessorDocs.navigateTo(null);}, [])}><i class="fas fa-home" aria-hidden="true"></i> Inicio</button>
                    ${this.breadcrumbs.map((b, i) => {
                        const last = i === this.breadcrumbs.length - 1;
                        return `<span class="dv-crumb-sep" aria-hidden="true">›</span><button type="button" class="dv-crumb ${last ? 'is-on' : ''}" ${last ? 'aria-current="page"' : ''} ${this.dropAttrs(b.id)} ${UIEvents.attr("click", function(event,captured){ProfessorDocs.navigateTo(String(captured[0]));}, [b.id])}>${Utils.sanitizeHTML(b.name)}</button>`;
                    }).join('')}
                    ${this.currentFolderId && manage ? `<button type="button" class="dv-crumb-del" ${UIEvents.attr("click", function(event,captured){ProfessorDocs.deleteItem(String(captured[0]));}, [this.currentFolderId])}><i class="fas fa-trash" aria-hidden="true"></i> Borrar carpeta</button>` : ''}
                </nav>
            </div>
            ${folders.length ? `
            <div class="dv-block">
                <span class="dv-mono">Carpetas</span>
                <div class="dv-folders">
                    ${folders.map(f => `<button type="button" class="dv-folder" ${this.dragAttrs(f.id)} ${this.dropAttrs(f.id)} ${UIEvents.attr('click', function(event,captured){ProfessorDocs.navigateTo(String(captured[0]));}, [f.id])}>
                        <span class="dv-folder-icon" aria-hidden="true"><i class="fas fa-folder"></i></span>
                        <span class="dv-person-text"><strong title="${Utils.sanitizeHTML(f.name)}">${Utils.sanitizeHTML(f.name)}</strong><span>${inside(f.id) ? this.plural(inside(f.id), 'elemento', 'elementos') : 'Vacía'}</span></span>
                    </button>`).join('')}
                </div>
            </div>` : ''}
            <div class="dv-block-row">
                <span class="dv-mono">${this.currentFolderId ? `En «${Utils.sanitizeHTML(where)}» · ${files.length}` : `Sueltos en Inicio · ${files.length}`}</span>
                ${files.length ? `<span class="dv-hint">${manage && (folders.length || this.currentFolderId) ? 'Pulsa uno para verlo · arrástralo a una carpeta para moverlo' : 'Pulsa uno para verlo al lado'}</span>` : ''}
            </div>
            <div id="docs-grid">
            ${files.length ? `
            <table class="dv-table">
                <thead><tr><th scope="col">Archivo</th><th scope="col">Tamaño</th><th scope="col">Subido</th></tr></thead>
                <tbody>
                    ${files.map(item => {
                        const on = item.id === this.selectedId;
                        return `<tr class="dv-row ${on ? 'is-on' : ''}" ${this.dragAttrs(item.id)}>
                            <td><button type="button" class="dv-file" data-id="${Utils.sanitizeHTML(item.id)}" ${on ? 'aria-current="true"' : ''} ${UIEvents.attr('click', function(event,captured){ProfessorDocs.select(String(captured[0]));}, [item.id])}>
                                <span class="dv-ext ${this.isPdf(item) ? 'is-pdf' : ''}" aria-hidden="true">${this.isPdf(item) ? 'PDF' : 'IMG'}</span>
                                <span class="dv-person-text"><strong title="${Utils.sanitizeHTML(item.name)}">${Utils.sanitizeHTML(item.name)}</strong><span>${Utils.sanitizeHTML(where)}</span></span>
                            </button></td>
                            <td class="dv-num">${this.formatFileSize(item.size) || '—'}</td>
                            <td class="dv-num">${this.formatDate(item.timestamp)}</td>
                        </tr>`;
                    }).join('')}
                </tbody>
            </table>` : `<p class="dv-empty">${folders.length ? 'No hay archivos sueltos aquí.' : 'Esta carpeta está vacía. Empieza creando una carpeta o subiendo un archivo.'}</p>`}
            </div>
            <span class="dv-grow"></span>
            ${manage ? `
            <label class="dv-drop" id="docs-drop-zone" for="docs-file-input">
                <span class="dv-drop-icon" aria-hidden="true"><i class="fas fa-cloud-upload-alt"></i></span>
                <span class="dv-person-text"><strong>Arrastra aquí para subirlo a «${Utils.sanitizeHTML(where)}»</strong><span>PDF o imagen (PNG, JPEG, GIF o WebP) · hasta 2 MB · o pulsa para elegirlo</span></span>
            </label>` : ''}`;
    },

    selectedItem() {
        return this.getAllDocs().find(d => d.id === this.selectedId && d.type !== 'folder' && d.parentId === this.currentFolderId) || null;
    },

    renderDetail() {
        const item = this.selectedItem();
        if (!item) {
            return `<div class="dv-detail-empty"><i class="far fa-file-alt" aria-hidden="true"></i><strong>Ningún archivo elegido</strong><span>Pulsa un archivo de la lista para verlo aquí sin abrir ventanas.</span></div>`;
        }
        return `
            <div class="dv-preview" id="dv-preview" aria-label="Vista previa del documento"><span class="dv-hint"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Cargando…</span></div>
            <div class="dv-detail-body">
                <div class="dv-person-text"><h2 class="dv-file-name">${Utils.sanitizeHTML(item.name)}</h2><span>${this.isPdf(item) ? 'PDF' : 'Imagen'} · ${this.formatFileSize(item.size) || '—'}</span></div>
                <dl class="dv-facts">
                    <dt>Carpeta</dt><dd>${Utils.sanitizeHTML(this.currentFolderName())}</dd>
                    <dt>Subido</dt><dd>${this.formatDate(item.timestamp)}</dd>
                    <dt>De</dt><dd>${Utils.sanitizeHTML(this.ownerName(item.professorId))}</dd>
                </dl>
                ${this.canManage() ? this.renderMoveField(item) : ''}
                <div class="dv-detail-actions">
                    <button type="button" class="dv-btn is-primary dv-grow-btn" ${UIEvents.attr('click', function(event,captured){ProfessorDocs.download(String(captured[0]));}, [item.id])}><i class="fas fa-download" aria-hidden="true"></i> Descargar</button>
                    <button type="button" class="dv-icon-btn" aria-label="Abrir en grande" title="Abrir en grande" ${UIEvents.attr('click', function(event,captured){ProfessorDocs.previewFile(String(captured[0]));}, [item.id])}><i class="fas fa-expand" aria-hidden="true"></i></button>
                    ${this.canManage() ? `<button type="button" class="dv-icon-btn is-danger" aria-label="Borrar archivo" title="Borrar archivo" ${UIEvents.attr('click', function(event,captured){ProfessorDocs.deleteItem(String(captured[0]));}, [item.id])}><i class="fas fa-trash" aria-hidden="true"></i></button>` : ''}
                </div>
                <p class="dv-foot">Si borras una carpeta se borra con todo lo que tiene dentro. Siempre se pide confirmación.</p>
            </div>`;
    },

    renderMoveField(item) {
        const docs = this.getAllDocs();
        const here = item.parentId ?? null;
        const options = [{ id: '', path: 'Inicio' }, ...docs.filter(d => d.type === 'folder').map(d => ({ id: d.id, path: this.folderPath(d.id, docs) }))]
            .filter(o => (o.id || null) !== here)
            .sort((a, b) => a.id === '' ? -1 : b.id === '' ? 1 : a.path.localeCompare(b.path, 'es'));
        if (!options.length) return '';
        return `<label class="dv-move"><span class="dv-mono">Mover a</span>
            <select class="form-select" id="dv-move-select" ${UIEvents.attr('change', function(event,captured){if(this.value!=='-')ProfessorDocs.moveItem(String(captured[0]), this.value||null);}, [item.id])}>
                <option value="-" selected>Elige carpeta…</option>
                ${options.map(o => `<option value="${Utils.sanitizeHTML(o.id)}">${Utils.sanitizeHTML(o.path)}</option>`).join('')}
            </select></label>`;
    },

    // Only the parts under the header change: no full-page repaint when picking a person, folder or file.
    refresh() {
        const main = document.getElementById('dv-main');
        if (!main) { App.navigate('documentos', false); return; }
        PrivateDownloads.clearInlinePreview(document.getElementById('dv-preview'));
        this._previewUrl = null;
        SafeHTML.set(main, this.renderMain());
        this.refreshDetail();
        this.refreshPeople();
        const manage = !this.canManage();
        ['docs-new-folder-btn', 'docs-upload-btn'].forEach(id => { const b = document.getElementById(id); if (b) b.disabled = manage; });
        this.setupDropZone();
    },

    refreshPeople() {
        const list = document.getElementById('dv-people-list');
        if (list) SafeHTML.set(list, this.renderPeople());
    },

    refreshDetail() {
        const detail = document.getElementById('dv-detail');
        if (!detail) return;
        PrivateDownloads.clearInlinePreview(document.getElementById('dv-preview'));
        this._previewUrl = null;
        SafeHTML.set(detail, this.renderDetail());
        this.loadDetailPreview();
    },

    renderDocs() { this.refresh(); },

    select(id) {
        this.selectedId = id;
        document.querySelectorAll('#dv-main .dv-file').forEach(button => {
            const on = button.dataset.id === id;
            button.closest('.dv-row')?.classList.toggle('is-on', on);
            if (on) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
        });
        this.refreshDetail();
    },

    async loadDetailPreview() {
        const item = this.selectedItem();
        const box = document.getElementById('dv-preview');
        if (!item || !box) return;
        try {
            const url = await PrivateDownloads.renderStoredPreview(box, item.fileData, item.fileType, 'professor-docs.json', item.id);
            if (this.selectedId === item.id) this._previewUrl = url;
        } catch (error) {
            if (box.isConnected) SafeHTML.set(box, `<span class="dv-hint">No se pudo cargar la vista previa: ${Utils.sanitizeHTML(error.message)}</span>`);
        }
    },

    async download(id) {
        const item = this.getAllDocs().find(d => d.id === id);
        if (!item) return;
        let url = this.selectedId === id ? this._previewUrl : null;
        if (!url) {
            try { url = await PrivateDownloads.renderStoredPreview(document.createElement('div'), item.fileData, item.fileType, 'professor-docs.json', item.id); }
            catch (error) { Utils.showToast(error.message, 'error'); return; }
        }
        const link = document.createElement('a');
        link.href = url;
        link.download = item.name;
        link.click();
    },

    formatFileSize(bytes) {
        if (!bytes) return '';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    },

    navigateTo(id) {
        if (id === null) {
            this.currentFolderId = null;
            this.breadcrumbs = [];
        } else {
            const all = this.getAllDocs();
            const folder = all.find(d => d.id === id);
            if (folder) {
                this.currentFolderId = id;
                // Rebuild breadcrumbs
                const newCrumbs = [];
                let curr = folder;
                while (curr) {
                    newCrumbs.unshift({ id: curr.id, name: curr.name });
                    curr = all.find(d => d.id === curr.parentId);
                }
                this.breadcrumbs = newCrumbs;
            }
        }
        this.selectedId = null;
        // From the sidebar folder tree the page may not be open yet.
        if (document.getElementById('dv-main')) this.refresh(); else App.navigate('documentos');
    },

    openNewFolderModal() {
        if(!this.canManage() || !this.selectedOwner())return;
        document.getElementById('modal-new-folder').style.display = 'flex';
        const where = document.getElementById('dv-folder-where');
        if (where) where.textContent = `Dentro de «${this.currentFolderName()}»`;
        document.getElementById('folder-name-input').value = '';
        document.getElementById('folder-name-input').focus();
    },

    async createFolder() {
        if(!this.canManage() || !this.selectedOwner())return;
        const nameInput = document.getElementById('folder-name-input');
        const name = nameInput.value.trim();
        if (!name) {
            Utils.showToast('Pon un nombre a la carpeta', 'warning');
            return;
        }

        const newFolder = {
            id: 'folder_' + Date.now(),
            professorId: this.selectedOwner(),
            parentId: this.currentFolderId,
            name: name,
            type: 'folder',
            timestamp: new Date().toISOString()
        };

        const docs = this.getAllDocs();
        docs.push(newFolder);
        if (!await this.saveDocs(docs)) return;
        this.closeModal('modal-new-folder');
        this.refresh();
        Utils.showToast('Carpeta creada con éxito', 'success');
    },

    // «Subir archivo» opens the file picker straight away: the file goes to the folder on screen.
    openUploadModal() {
        if(!this.canManage() || !this.selectedOwner())return;
        document.getElementById('docs-file-input')?.click();
    },

    setupDropZone() {
        const input = document.getElementById('docs-file-input');
        if (input && !input.dataset.bound) {
            input.dataset.bound = '1';
            input.onchange = () => { const file = input.files[0]; if (file) this.handleFileUpload(file); };
        }
        const zone = document.getElementById('docs-drop-zone');
        if (!zone) return;
        zone.ondragover = event => { if (this._dragId) return; event.preventDefault(); zone.classList.add('is-over'); };
        zone.ondragleave = () => zone.classList.remove('is-over');
        zone.ondrop = event => {
            if (this._dragId) return;
            event.preventDefault();
            zone.classList.remove('is-over');
            const file = event.dataTransfer?.files?.[0];
            if (file) this.handleFileUpload(file);
        };
    },

    handleFileUpload(file) {
        if(!this.canManage() || !this.selectedOwner())return;
        if (this._uploadPending) return;
        const input = document.getElementById('docs-file-input');
        file = file || input?.files[0];
        if (input) input.value = '';
        if (!file) return;
        if (!['application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp'].includes(file.type)) {
            Utils.showToast('Solo PDF o imagen PNG, JPEG, GIF o WebP', 'error');
            return;
        }
        if (file.size > 2 * 1024 * 1024) {
            Utils.showToast('Máximo 2MB permitido', 'error');
            return;
        }

        this._uploadPending = true;
        const button = document.getElementById('docs-upload-btn');
        const zone = document.getElementById('docs-drop-zone');
        const previous = button ? button.innerHTML : '';
        if (button) { button.disabled = true; button.textContent = 'Subiendo…'; button.setAttribute('aria-busy','true'); }
        zone?.classList.add('is-busy');
        const finish = () => {
            this._uploadPending = false;
            if (button) { SafeHTML.set(button, previous); button.disabled = !this.canManage(); button.removeAttribute('aria-busy'); }
            document.getElementById('docs-drop-zone')?.classList.remove('is-busy');
        };
        const reader = new FileReader();
        reader.onerror = () => { Utils.showToast('No se pudo leer el archivo. Selecciónalo de nuevo.', 'error'); finish(); };
        reader.onload = async (e) => {
            try {
            const newFile = {
                id: 'file_' + Date.now(),
                professorId: this.selectedOwner(),
                parentId: this.currentFolderId,
                name: file.name,
                type: 'file',
                fileType: file.type,
                fileData: e.target.result,
                size: file.size,
                timestamp: new Date().toISOString()
            };

            const docs = this.getAllDocs();
            docs.push(newFile);
            if (!await this.saveDocs(docs)) return;
            this.selectedId = newFile.id;
            this.refresh();
            Utils.showToast('Archivo subido con éxito', 'success');
            } finally { finish(); }
        };
        reader.readAsDataURL(file);
    },

    closeModal(id) {
        document.getElementById(id).style.display = 'none';
    },

    deleteItem(id) {
        if(!this.canManage())return;
        const target = this.getAllDocs().find(d => d.id === id);
        const message = target?.type === 'folder' ? `¿Borrar la carpeta «${target.name}» con todo lo que tiene dentro?` : '¿Estás seguro de eliminar este elemento?';
        Utils.showConfirm(message, async () => {
            let docs = this.getAllDocs();
            // Recursive delete if folder
            const toDelete = [id];
            const findChildren = (pid) => {
                docs.filter(d => d.parentId === pid).forEach(child => {
                    toDelete.push(child.id);
                    if (child.type === 'folder') findChildren(child.id);
                });
            };
            const item = docs.find(d => d.id === id);
            if (item && item.type === 'folder') findChildren(id);

            docs = docs.filter(d => !toDelete.includes(d.id));
            if (!await this.saveDocs(docs)) return;
            if (toDelete.includes(this.selectedId)) this.selectedId = null;
            // Deleting the open folder goes back to its parent.
            if (toDelete.includes(this.currentFolderId)) {
                this.currentFolderId = item?.parentId ?? null;
                this.breadcrumbs = this.breadcrumbs.slice(0, this.breadcrumbs.findIndex(b => b.id === id));
            }
            this.refresh();
            Utils.showToast('Eliminado correctamente', 'info');
        });
    },

    async previewFile(id) {
        const item = this.getAllDocs().find(d => d.id === id);
        if (!item) return;

        const modal = document.getElementById('docs-preview-modal');
        const content = document.getElementById('docs-modal-content');
        const title = document.getElementById('docs-modal-title');
        const downloadBtn = document.getElementById('docs-modal-download');

        title.textContent = item.name;
        let previewUrl;
        try { previewUrl = await PrivateDownloads.renderStoredPreview(content, item.fileData, item.fileType, 'professor-docs.json', item.id); }
        catch (error) { Utils.showToast(error.message, 'error'); return; }

        downloadBtn.onclick = () => {
            const link = document.createElement('a');
            link.href = previewUrl;
            link.download = item.name;
            link.click();
        };

        modal.style.display = 'flex';
        setTimeout(() => {
            modal.style.opacity = '1';
            modal.querySelector('.modal-container').style.transform = 'scale(1)';
        }, 10);
    },

    closePreview() {
        PrivateDownloads.clearInlinePreview(document.getElementById('docs-modal-content'));
        const modal = document.getElementById('docs-preview-modal');
        modal.style.opacity = '0';
        modal.querySelector('.modal-container').style.transform = 'scale(0.9)';
        setTimeout(() => {
            modal.style.display = 'none';
            SafeHTML.set(document.getElementById('docs-modal-content'), '');
        }, 300);
    }
};

window.ProfessorDocs = ProfessorDocs;
